import React from "react";
import { Breadcrumb, Button, Card, Col, Form, Input, Row, Select, Spin, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken } from "../services/api";
import { IoEye, IoEyeOff } from "react-icons/io5";


class UsuarioForm extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        _type: this.props.type === 'add' ? 'Adicionar' : 'Editar',
        defaultValue: null,
        doc: false,
        fileList: [],
        filters: { STATUS: [], TYPE_CREDENTIAL_ID: [] },
        setor: [],
        visible: false
    }

    componentDidMount = () => {
        this.onView()
        POST_API('/setor/search.php', { token: getToken(), type: this.props.type }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({ setor: res.data })
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onView = async () => {
        var filter = { ID: this.state._params[5] }
        POST_API('/credential/search.php', { token: getToken(), type: 'view', filter: JSON.stringify(filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        if (this.props.account) values.ACCOUNT_ID = this.state._params[5]
        POST_API('/credential/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))
    }

    back = "/dashboard/users/";

    routes = [
        {title: <Link to={this.back}><Typography className="page-bread">Usuários</Typography></Link>},
        {title: <Typography className="page-bread active">{this.props.type === 'add' ? 'Adicionar' : 'Editar'}</Typography>},
    ]

    render = () => {

        if (this.state._navigate) {
            return (<Navigate to={this.back} />)
        }

        return (
            <Row className="page-content">
                <Col span={18} style={{marginBottom: '18px'}}>
                    <Breadcrumb items={this.routes} />
                </Col>
                <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Link to={this.back}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                </Col>
                { this.state._screen ? <Col span={24}><center><Spin /></center></Col> : (
                    <Col span={24}>
                        <Card>
                            <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                <Form.Item hidden name="ID">
                                    <Input />
                                </Form.Item>
                                <Row gutter={[16,0]}>
                                    <Col md={9} xs={24}>
                                        <Form.Item label="Nome" name="NAME" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col md={6} xs={24}>
                                        <Form.Item label="E-mail" name="LOGIN" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}, {type: 'email', message: 'E-mail inválido'}]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col md={4} xs={24}>
                                        <Form.Item label="Tipo Usuário" name="TYPE" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                            <Select>
                                                <Select.Option value={'C'}>Colaborador</Select.Option>
                                                <Select.Option value={'RH'}>RH</Select.Option>
                                                <Select.Option value={'MK'}>Comunicação</Select.Option>
                                                <Select.Option value={'A'}>Admin</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col md={5} xs={24}>
                                        <Form.Item label="Senha" name="PASSWORD" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório'}]}>
                                            <Input type={ this.state.visible ? "text" : "password" } addonAfter={ this.state.visible ? <Button onClick={() => this.setState({visible: false})} shape="circle" type="text" size="small"><IoEyeOff /></Button> : <Button onClick={() => this.setState({visible: true})} shape="circle" type="text" size="small"><IoEye /></Button>}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Salvar</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                )}
            </Row>
        )

    }

}

export default UsuarioForm;